import ZJApi from './api'
import utils from '../../utils'

const info = {
    service: 'UniformAuthService',
    controller: 'FuncInfo'
}
const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GeItemById',
    'GetItemPagingList',
    'GetItemPagingListByMenuId',
    'GetAllItems',
    'FindFuncsByMenuId'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const FuncApi = ZJApi.defineNewApi('FuncApi', factory)

export default FuncApi